<template>
	<router-view></router-view>
  <teleport to="body">
    <transition name="fade">
      <div v-if="state.showModal" class="modal" tabindex="-1" role="dialog" @click="hideModal()">
        <div class="modal-dialog modal-lg" role="document" @click.stop>
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ state.selectedModal.title }}</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="hideModal()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <p v-html="state.selectedModal.text"></p>
            </div>
            <div class="modal-footer">
              <button class="btn btn-secondary" data-dismiss="modal" @click="hideModal()">
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script>
import store from "@/store";

export default {
	name: "App",
	components: {},
	setup() {
	},
	data() {
		return {
			state: store.state
		}
	},
  methods: {
    showModal(modal) {
      store.showModal(modal);
    },
    hideModal() {
      store.hideModal();
    }
  }
};
</script>

<style src="./assets/style.css" lang="css" ></style>

<style scoped>
#app {
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: #2c3e50;
	margin-top: 60px;
}

.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, .5);
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 10000;
}
.modal-dialog {
    position: relative;
    width: auto;
    margin: .5rem;
    pointer-events: none;
}
@media (min-width: 576px) {
	.modal {
		justify-content: center;
	}
}
</style>
